export const getExistingReusableCustomProcessorId = (source = {}) => {
  const sourceConfig = source?.source_config;

  if (!sourceConfig) return null;

  const isReusableCustomProcessorEnabled =
    sourceConfig['ui.use_custom_processor'] &&
    sourceConfig['ui.custom_processor_mode'] === 'reusable_code_container';

  if (!isReusableCustomProcessorEnabled) return null;

  if (source?.code_container_id !== undefined && source?.code_container_id !== null) {
    return source.code_container_id;
  }

  const fallbackId = sourceConfig?.post_processor?.[0]?.code_container_id;
  return fallbackId || null;
};
